import api from './api';

const resource = 'RefundApproval/';

const refundApprovalApi = {
  approve: async (id) => {
    return await api.post(resource + `Approve?id=${id}`);
  },
};

export default refundApprovalApi;
